import { ChangeDetectorRef, Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StorageService } from '../../services/common/storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../services/common/common.service';
import { ApiService } from '../../services/api.service';
import { ApiUrlHelper } from '../../services/api-url-helper/api-url-helper';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { VerifyOtpMessageDialogueComponent } from '../verify-otp-message-dialogue/verify-otp-message-dialogue.component';
import { MatDialog } from '@angular/material/dialog';
import { DeletePopupComponent } from '../common/delete-popup/delete-popup.component';
import { PasswordMessageDialogueComponent } from '../password-message-dialogue/password-message-dialogue.component';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/languageService/language-service.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent {
  forgetPasswordForm: FormGroup;
  isPartnerFlow: boolean = false;
  constructor(
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private storageService: StorageService,
    private router: Router,
    private commonService: CommonService,
    private apiService: ApiService,
    private apiUrl: ApiUrlHelper,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
    private cdRef: ChangeDetectorRef,
    private translate:TranslateService,
    private languageService: LanguageService,
    private route: ActivatedRoute,
   
  ) {
    this.forgetPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required,Validators.pattern(this.commonService.emailRegex)]],
    });
  }
  ngOnInit(): void {
    this.languageService.language$.subscribe(language => {
      this.translate.use(language);
    });
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.storageService.clearAll();

    const userType = this.route.snapshot.queryParamMap.get('userType');
    if (userType === '5') {
      this.isPartnerFlow = true;
    }
    
    history.pushState(null, '', location.href);
    window.addEventListener('popstate', () => {
      window.location.href = '/login'; // Forces reload and redirects
    });
  }
  onSubmit() {
    if(this.forgetPasswordForm.invalid){
      this.forgetPasswordForm.markAllAsTouched();
      return;
    }
    Object.keys(this.forgetPasswordForm.controls).forEach((key) => {
      const control = this.forgetPasswordForm.get(key);
      if (control && typeof control.value === 'string') {
        control.setValue(control.value.trim(), { emitEvent: false });
      }
    });
    const FormData = {
      email: this.forgetPasswordForm.controls['email'].value.trim(),
    };
    this.storageService.setValue('email', FormData.email);
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.forgetPassword.forgetPassword;
    this.apiService
      .doPost(apiUrl, FormData)
      .pipe()
      .subscribe({
        next: (response) => {
          this.spinner.hide();
          if (response && response.Success) {
            this.toaster.success(this.translate.instant(response.Message));
            if (this.isPartnerFlow) {
              this.storageService.setValue('userTypeId', '5');
            }
            this.router.navigate(['/confirm-forget-password']);
          } else {
            const dialogRef = this.dialog.open(
              PasswordMessageDialogueComponent,
              {
                width: '500px',
                panelClass:'error-popup',
                data: {
                  // data will be based on API response
                  passwordError:true,
                  title: 'ACCOUNT_NOT_FOUND_ERROR',
                  message: 'ACCOUNT_NOT_FOUND_DESC'
                },
              }
            );
            //this.toaster.error(response.Message);
          }
        },
        error: (er) => {
          this.spinner.hide();
          console.error(er);
         // this.toaster.error(er.Message);
        },
      });
  }

  onSignup(){
    if (this.isPartnerFlow) {
      this.router.navigate(['/signup'], { queryParams: { userType: '5' } });
    } else {
      this.router.navigate(['/signup']);
    }
  }
}
